module.exports = new __parcel__URL__("item-list-app-skeleton.tpl.303599a3.svg").toString();